import './GenericModal.scss';
import React from "react";
import type {PaperProps} from "@mui/material";
import {Button, CircularProgress, Dialog, Grid, Typography} from "@mui/material";
import {Check, Close} from "@mui/icons-material";

// TODO: Move this to a more generic component and set the ID field properly
// This is the original component that was is more wide
export const GenericModel: React.FC<{
    className?: string

    isOpen: boolean,

    paperProps?: Partial<PaperProps>,

    onSave: () => void
    saveDisabled?: boolean
    saveTitle?: string,

    onCancel: () => void
    cancelDisabled?: boolean
    cancelTitle?: string,

    title: string
    titleId?: string

    isLoading?: boolean
    children?: React.ReactNode
}> = ({
          className,
          isOpen,
          onSave,
          saveDisabled,
          saveTitle,
          onCancel,
          cancelDisabled,
          cancelTitle,
          title,
          titleId,
          isLoading,
          paperProps,
          children,
      }) => {
    className = "edit-model-component" + (className ? ' ' + className : '');
    titleId = titleId || 'generic-modal';
    return (
        <Dialog
            open={isOpen}
            onClose={onCancel}
            aria-labelledby={titleId}
            maxWidth="lg"
            PaperProps={paperProps as any}
        >
            <Grid container className={className}>
                <Grid
                    container
                    direction="column"
                    justifyContent="flex-start"
                    alignItems="stretch"
                    spacing={3}
                    size={8}>
                    <Grid>
                        <Typography id={titleId || ''} variant="h5">
                            {title}
                        </Typography>
                    </Grid>
                    <Grid>
                        {children}
                    </Grid>
                </Grid>
                <Grid size={2}/>
                <Grid
                    alignItems="stretch"
                    container
                    direction="column-reverse"
                    justifyContent="space-between"
                    size={2}>
                    <Grid>
                        <Button
                            fullWidth
                            disabled={saveDisabled || isLoading}
                            startIcon={<Check/>}
                            onClick={onSave}
                            endIcon={isLoading && <CircularProgress size={20}/> || undefined}
                            variant="outlined"
                            // tabIndex="2"
                        >
                            {saveTitle || 'Save'}
                        </Button>
                    </Grid>
                    <Grid>
                        <Button
                            fullWidth
                            disabled={cancelDisabled || isLoading}
                            className="btn-red"
                            startIcon={<Close/>}
                            onClick={onCancel}
                            variant="outlined"
                            // tabIndex="3"
                        >
                            {cancelTitle || 'Cancel'}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Dialog>
    );
}

